import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Bell, CheckCircle, Info, AlertCircle, X, CheckCheck } from 'lucide-react';
import { useNotifications } from '../contexts/NotificationContext';

const Notifications = () => {
  const { notifications, unreadCount, markAsRead, markAllAsRead, deleteNotification, clearAllNotifications } = useNotifications();

  const getNotificationIcon = (type) => {
    switch (type) {
      case 'success':
        return <CheckCircle size={20} color="#10b981" />;
      case 'warning':
        return <AlertCircle size={20} color="#f59e0b" />;
      case 'error':
        return <AlertCircle size={20} color="#ef4444" />;
      default:
        return <Info size={20} color="#3b82f6" />;
    }
  };

  const getNotificationBgColor = (type) => {
    switch (type) {
      case 'success':
        return '#dcfce7';
      case 'warning':
        return '#fef3c7';
      case 'error':
        return '#fee2e2';
      default:
        return '#dbeafe';
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffInSeconds = Math.floor((now - date) / 1000);
    
    if (diffInSeconds < 60) {
      return 'Just now';
    } else if (diffInSeconds < 3600) {
      const minutes = Math.floor(diffInSeconds / 60);
      return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
    } else if (diffInSeconds < 86400) {
      const hours = Math.floor(diffInSeconds / 3600);
      return `${hours} hour${hours > 1 ? 's' : ''} ago`;
    } else if (diffInSeconds < 604800) {
      const days = Math.floor(diffInSeconds / 86400);
      return `${days} day${days > 1 ? 's' : ''} ago`;
    } else {
      return date.toLocaleDateString();
    }
  };

  return (
    <div className="container">
      <div className="notifications-header">
        <Link to="/dashboard" className="btn btn-secondary back-to-dashboard">
          <ArrowLeft size={16} style={{ marginRight: '8px' }} />
          Back to Dashboard
        </Link>
        
        <div className="notifications-title-section">
          <div className="notifications-title-wrapper">
            <Bell size={24} style={{ marginRight: '12px' }} />
            <h1 className="text-3xl font-bold" style={{ color: '#0477aa' }}>Notifications</h1>
            {unreadCount > 0 && (
              <span className="notification-badge-header">{unreadCount}</span>
            )}
          </div>
          {notifications.length > 0 && (
            <div className="notifications-actions">
              {unreadCount > 0 && (
                <button
                  onClick={markAllAsRead}
                  className="btn btn-secondary"
                  style={{ marginRight: '0.5rem' }}
                >
                  <CheckCheck size={16} style={{ marginRight: '8px' }} />
                  Mark All as Read
                </button>
              )}
              <button
                onClick={clearAllNotifications}
                className="btn btn-secondary"
              >
                Clear All
              </button>
            </div>
          )}
        </div>
      </div>

      <div className="notifications-list">
        {notifications.length > 0 ? (
          notifications.map((notification) => (
            <div
              key={notification.id}
              className={`notification-card ${notification.read ? 'read' : 'unread'}`}
              style={{ borderLeftColor: getNotificationBgColor(notification.type) }}
            >
              <div className="notification-content">
                <div className="notification-icon-wrapper" style={{ backgroundColor: getNotificationBgColor(notification.type) }}>
                  {getNotificationIcon(notification.type)}
                </div>
                <div className="notification-text">
                  <div className="notification-header">
                    <h3 className={`notification-title ${notification.read ? '' : 'font-bold'}`}>
                      {notification.title}
                    </h3>
                    {!notification.read && (
                      <span className="notification-unread-dot"></span>
                    )}
                  </div>
                  <p className="notification-message">{notification.message}</p>
                  <span className="notification-time">{formatDate(notification.createdAt)}</span>
                </div>
              </div>
              <div className="notification-actions">
                {!notification.read && (
                  <button
                    onClick={() => markAsRead(notification.id)}
                    className="notification-action-btn"
                    title="Mark as read"
                  >
                    <CheckCircle size={18} />
                  </button>
                )}
                <button
                  onClick={() => deleteNotification(notification.id)}
                  className="notification-action-btn"
                  title="Delete"
                >
                  <X size={18} />
                </button>
              </div>
            </div>
          ))
        ) : (
          <div className="card text-center py-12">
            <div className="text-gray-500 mb-4">
              <Bell size={48} className="mx-auto mb-4" style={{ opacity: 0.5 }} />
              <h3 className="text-xl font-semibold mb-2">No Notifications</h3>
              <p>You're all caught up! You don't have any notifications at the moment.</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Notifications;

